import { Accordion, Icon, Label, Message, Segment } from "semantic-ui-react";
import React from "react";
import ResourceRow from "../ResourceRow";
import styles from "../Resources.module.css"


const DefaultFamilyResourceSlide1 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Holding a Family Meeting from the Family Caregiving Alliance"
          url="https://www.caregiver.org/resource/holding-family-meeting/"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="How to Share Caregiving Responsibilities with Family Members"
          url="https://www.nia.nih.gov/health/how-share-caregiving-responsibilities-family-members"
          descriptionText=""
        />
        <ResourceRow urlText="Caregiving with Your Siblings From the Family Caregiver Alliance "
          url="https://www.caregiver.org/resource/caregiving-with-your-siblings/?via=caregiver-resources,all-resources"
          descriptionText=""
        />
        <ResourceRow urlText="Long-Distance Caregiving"
          url="https://www.nia.nih.gov/health/getting-started-long-distance-caregiving"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide2 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Pets for the Elderly "
          url="https://www.petsfortheelderly.org/our-work/research.php"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Health Benefits of Companion Animals"
          url="https://cvm.msu.edu/news/perspectives-magazine/perspectives-fall-2018/the-health-benefits-of-owning-a-companion-animal"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide3 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Emergency Tips"
          url="https://www.ready.gov/sites/default/files/2020-03/ready_prepare-now-seniors.pdf"
          taskHeaderText={textTitle}
          descriptionText=""
        />
        <ResourceRow urlText="In Case of Emergency Form"
          url="https://acl.gov/sites/default/files/programs/2018-10/EmergencyInformation.pdf"
          descriptionText=""
        />
        <ResourceRow urlText="Preparing with Older Adults"
          url="https://www.redcross.org/get-help/how-to-prepare-for-emergencies/older-adults.html"
          descriptionText=""
          groupedHeaderText="Preparing for Emergencies"
        />
        <ResourceRow urlText="Creating Plans"
          url="https://www.ready.gov/plan"
          descriptionText=""
        />
        <ResourceRow urlText="Red Cross Preparedness Checklist"
          url="https://www.redcross.org/content/dam/redcross/get-help/how-to-prepare/Older_Adults_Disaster_Prep_1Pager_11012022.pdf"
          descriptionText=""
        />
        <ResourceRow urlText="Hurricane Evacuation Planning with Pets"
          url="http://www.coastalpetrescue.org/hurricane.html"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide4 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="CDC - A Home Fall Prevention Checklist for Older Adults"
          url="https://uvahealth.com/sites/default/files/2018-08/Fall-Prevention-Checklist.pdf"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Safe At Home Checklist"
          url="https://www.aota.org/~/media/Corporate/Files/Practice/Aging/rebuilding-together/RT-Aging-in-Place-Safe-at-Home-Checklist.pdf"
        />
        <ResourceRow urlText="Home Modifications"
          url="https://acl.gov/sites/default/files/news%202017-03/Home_Modification.pdf"
        />
        <ResourceRow urlText="Health in Aging Tip Sheet"
          url="https://www.healthinaging.org/tools-and-tips/tip-sheet-home-safety-tips-older-adults"
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide5 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Older Adults and Technology Use"
          url="https://www.pewresearch.org/internet/2014/04/03/older-adults-and-technology-use/"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="How Technology Can Help Seniors"
          url="https://www.seniorliving.org/tech/"
          descriptionText=""
        />
        <ResourceRow urlText="Calming Computer Jitters: Help for Seniors Who Aren't Tech-Savvy"
          url="https://khn.org/news/article/calming-computer-jitters-help-for-seniors-who-arent-tech-savvy/"
          descriptionText=""
          groupedHeaderText="Tech Tips for Seniors"
        />
        <ResourceRow urlText="Tips on Helping Seniors Learn Technology"
          url="https://www.saberhealth.com/news/blog/help-seniors-learn-technology"
          descriptionText=""
        />
        <ResourceRow urlText="Technology for Seniors Made Easy"
          url="https://www.rightathome.net/blog/technology-for-seniors"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide6 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Tips for Hiring In-Home Help Through an Agency"
          url="https://www.caregiver.org/resource/10-tips-for-hiring-in-home-help-through-an-agency/"
          descriptionText=""
          taskHeaderText={textTitle}
          groupedHeaderText="Tips for Finding a Caregiver"
        />
        <ResourceRow urlText="Hiring In-Home Help"
          url="https://www.caregiver.org/resource/hiring-home-help/"
          descriptionText=""
        />
        <ResourceRow urlText="Hiring an In-Home Caregiver: A Step-by-Step Guide"
          url="https://www.aplaceformom.com/caregiver-resources/articles/hiring-an-in-home-caregiver"
          descriptionText=""
        />
        <ResourceRow urlText="How to Hire In-Home Help"
          url="https://www.consumerreports.org/elder-care/how-to-hire-in-home-help/"
          descriptionText=""
        />
        <ResourceRow urlText="Choosing an In-Home Care Provider"
          url="https://udservices.org/in-home-care-provider-questions/"
          descriptionText=""
          groupedHeaderText="Tips for Finding a Caregiver for Hospice and/or Alzheimer's Patients"
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide7 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="The Art of Grandparenting Publication"
          url="https://www.ag.ndsu.edu/publications/kids-family/the-art-of-grandparenting-no-1-in-the-series#section-9"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Long Distance Grandparenting"
          url="https://lastingthedistance.com/long-distance-grandparents/"
          descriptionText=""
        />
        <ResourceRow urlText="Online Grandparenting Classes"
          url="https://www.scripps.org/news_items/3385-grandparenting-classes-preparing-for-a-role-of-a-lifetime"
          descriptionText=""
        />
        <ResourceRow urlText="Joys & Challenges of Grandparenting"
          url="https://greatergood.berkeley.edu/article/item/how_to_navigate_the_joys_and_challenges_of_grandparenting"
          descriptionText=""
          groupedHeaderText="Grandparenting Tips"
        />
        <ResourceRow urlText="Grandkids Matter"
          url="https://grandkidsmatter.org/"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide8 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Reading the Family Narrative Backwards"
          url="http://newoldage.blogs.nytimes.com/2008/10/09/reading-the-family-narrativebackwards/?pagemode=print"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Techniques to Relieve Caregiver Stress"
          url="https://www.caringbridge.org/resources/techniques-to-relieve-caregiver-stress"
          descriptionText=""
        />
        <ResourceRow urlText="Caring for Yourself"
          url="https://www.caregiver.org/caregiver-resources/caring-for-yourself/"
          descriptionText=""
          groupedHeaderText="Tips on Preventing Caregiver Burnout"
        />
        <ResourceRow urlText="Resources for Taking Care of Yourself"
          url="https://www.caregiver.org/resource/taking-care-you-self-care-family-caregivers/"
          descriptionText=""
        />
        <ResourceRow urlText="What is Respite Care?"
          url="https://www.nia.nih.gov/health/what-respite-care"
          descriptionText=""
          groupedHeaderText="Information on Respite Care for Caregivers"
        />
        <ResourceRow urlText="Help & Support with Respite Care"
          url="https://www.alz.org/help-support/caregiving/care-options/respite-care"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide9 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Aging in Place with Habitat for Humanity "
          url="https://www.habitat.org/our-work/aging-in-place?gclid=CjwKCAiAmJGgBhAZEiwA1JZolisCDYmRYx_1iBXP3fJolaQzuiKMQQmQhEQe28k9OA5VWT3-pPbjAhoC7lgQAvD_BwE"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="The Home Maintenance Checklist For Retirees"
          url="https://www.forbes.com/sites/northwesternmutual/2015/11/02/the-home-maintenance-checklist-for-retirees/?sh=cef59e74fb37"
          descriptionText=""
        />
        <ResourceRow urlText="Home Maintenance Tips and Resources for Seniors"
          url="https://www.senioradvisor.com/blog/2016/12/home-maintenance-tips-and-resources-for-seniors/"
          descriptionText=""
          groupedHeaderText="Home Maintenance Tips"
        />
        <ResourceRow urlText="41 Home Maintenance Tips: Save Your House"
          url="https://lula.life/home-maintenance-tips"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultFamilyResourceSlide10 = (textTitle: string) => {
  return (

    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Widow's Connection"
          url="https://widowsconnection.org/"
          descriptionText=""
          groupedHeaderText="Support for Widows"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="National Widowers"
          url="https://nationalwidowers.org/"
          descriptionText=""
        />
        <ResourceRow urlText="Wings for Widows"
          url="https://wingsforwidows.org/"
          descriptionText=""
        />
        <ResourceRow urlText="The Widowhood Effect: How to Survive the Loss of a Spouse"
          url="https://www.ncoa.org/article/the-widowhood-effect-how-to-survive-the-loss-of-a-spouse"
          descriptionText=""
        />
        <ResourceRow urlText="What to Do When a Loved One Dies"
          url="https://www.aarp.org/home-family/friends-family/info-2020/when-loved-one-dies-checklist.html"
          descriptionText=""
        />
        <ResourceRow urlText="After Death Checklist"
          url="https://familycaregiversonline.net/after-death-checklist/"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const accordionResourceDisplay = (keyVal: string, title: string, slideFunction: any) => {

  const accordions = [
    {
      key: 'keyVal',
      index: 0,
      title: {
        icon: <Icon name='dropdown' className={styles.resourcesAccordionLabelTitleIcon} />,
        content: <Label className={styles.resourcesAccordionLabelTitle} > {title} </Label>
      },
      content: {
        content: (<Message className={styles.resourcesAccordionMessageBox} content={slideFunction()} />)
      }
    }
  ];

  return (
    <>
      <div className={styles.resourceAccordionWrapper}>
        <Accordion panels={accordions} defaultActiveIndex={0} />
      </div>
    </>
  );

}

const AllResources = () => {
  return (
    <>
      {accordionResourceDisplay('FamilyDomainTask1', 'Family Meeting Resources', () => DefaultFamilyResourceSlide1(""))}
      {accordionResourceDisplay('FamilyDomainTask2', 'Companion Animals Resources', () => DefaultFamilyResourceSlide2(""))}
      {accordionResourceDisplay('FamilyDomainTask3', 'Crisis Planning Resources', () => DefaultFamilyResourceSlide3(""))}
      {accordionResourceDisplay('FamilyDomainTask4', 'Home Safety Resources', () => DefaultFamilyResourceSlide4(""))}
      {accordionResourceDisplay('FamilyDomainTask5', 'Using Technology Resources', () => DefaultFamilyResourceSlide5(""))}
      {accordionResourceDisplay('FamilyDomainTask6', 'Choosing Paid Caregivers Resources', () => DefaultFamilyResourceSlide6(""))}
      {accordionResourceDisplay('FamilyDomainTask7', 'Grandparent Relationships Resources', () => DefaultFamilyResourceSlide7(""))}
      {accordionResourceDisplay('FamilyDomainTask8', 'Caring For Yourself Resources', () => DefaultFamilyResourceSlide8(""))}
      {accordionResourceDisplay('FamilyDomainTask9', 'Home Maintenance Resources', () => DefaultFamilyResourceSlide9(""))}
      {accordionResourceDisplay('FamilyDomainTask10', 'Widowhood Support Resources', () => DefaultFamilyResourceSlide10(""))}
    </>
  );
};

const FamilyResourcesFactory: React.FC<{
  questionKey: string;
}> = (props) => {
  const { questionKey } = props;

  switch (questionKey) {
    case "FamilyDomainTask1":
      return DefaultFamilyResourceSlide1('Family Meeting');
    case "FamilyDomainTask2":
      return DefaultFamilyResourceSlide2('Companion Animals');
    case "FamilyDomainTask3":
      return DefaultFamilyResourceSlide3('Crisis Planning');
    case "FamilyDomainTask4":
      return DefaultFamilyResourceSlide4('Home Safety');
    case "FamilyDomainTask5":
      return DefaultFamilyResourceSlide5('Using Technology');
    case "FamilyDomainTask6":
      return DefaultFamilyResourceSlide6('Choosing Paid Caregivers');
    case "FamilyDomainTask7":
      return DefaultFamilyResourceSlide7('Grandparent Relationships');
    case "FamilyDomainTask8":
      return DefaultFamilyResourceSlide8('Caring For Yourself');
    case "FamilyDomainTask9":
      return DefaultFamilyResourceSlide9('Home Maintenance');
    case "FamilyDomainTask10":
      return DefaultFamilyResourceSlide10('Widowhood Support');
    case "":
      return AllResources();
    default:
      return null;
  };
};

export default FamilyResourcesFactory;
